import { forwardRef, type Ref } from "react";

import { type SvgExtendedProps } from "./types";

function SvgDollarWarning(
  {
    strokeColor = "#0C1C43",
    gradientStartColor = "#ADF3C7",
    gradientEndColor = "#F6F3F1",
    ...props
  }: SvgExtendedProps,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg
      ref={ref}
      width="176"
      height="120"
      viewBox="0 0 176 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#dollarWarning_svg__clip)">
        <circle cx="88" cy="60" r="50" stroke="url(#dollarWarning_svg__paint)" strokeWidth="20" />
      </g>
      <path
        d="M88 41.7273V38M88 75.2727V79M95.796 47.3182C94.2398 45.09 91.3313 43.5909 88 43.5909H87C82.5817 43.5909 79 46.5576 79 50.2172V50.5017C79 53.1193 80.7855 55.5122 83.6121 56.6828L92.3879 60.3172C95.2145 61.4878 97 63.8807 97 66.4983C97 70.315 93.2645 73.4091 88.6565 73.4091H88C84.6687 73.4091 81.7602 71.91 80.204 69.6818"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="29.5" y="10.5" width="39" height="39" rx="19.5" fill="#0D2B57" />
      <rect x="29.5" y="10.5" width="39" height="39" rx="19.5" stroke="white" />
      <path
        d="M49 24V31M49 34V35"
        stroke="white"
        strokeWidth="1.51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="dollarWarning_svg__paint"
          x1="88"
          y1="10"
          x2="88"
          y2="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStartColor} />
          <stop offset="1" stopColor={gradientEndColor} />
        </linearGradient>
        <clipPath id="dollarWarning_svg__clip">
          <rect x="38" y="10" width="100" height="100" rx="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDollarWarning);
export default ForwardRef;
